import React from "react";

type Props = {};

const PhotoUpload = (props: Props) => {
  return (
    <div>
      <input type="file" name="profile-picture" />
    </div>
  );
};

export default PhotoUpload;
